<template>
  <div>
    <vue-toastr ref="mytoast"></vue-toastr>
    <table class="table table-hover">
      <thead>
      <tr>
        <th></th>
        <th>Themenwelt</th>
      </tr>
      </thead>
      <draggable v-model="topicWorlds" group="media" @start="drag=true" @end="updateMediaList" tag="tbody">
        <tr v-for="item in topicWorlds" :key="topicWorlds.id" style="cursor:grab;">
          <td style="width: 25px;"><i class="fa fa-bars" aria-hidden="true"></i></td>
          <td>{{ item.title }}</td>
        </tr>
      </draggable>
    </table>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import VueToastr from "vue-toastr";

export default {
  name: 'BmTopicWorldsOverview',
  components: {draggable, VueToastr},
  props: ['topicWorlds'],
  methods: {
    updateMediaList() {
      axios.post('/api/fmu/topic_worlds/reorder', {
        topicWorlds: this.topicWorlds
      }).then(() => {
        this.$refs.mytoast.s("Neue Sortierung gespeichert", "Erfolgreich");
      }).catch(() => {
        this.$refs.mytoast.e("Versuche es noch einmal", "Fehler");
      })
    }
  }
}
</script>

<style scoped>
</style>
